import { Header } from "./styles/Header.styled";
import { Footer } from "./styles/Footer.styled";
import logo from "./Assets/logo.svg";
import ContactStyled from "./styles/Contact.styled";
import { useState } from "react";

const Contact = () => {
  const [isClick, setIsClick] = useState(false);
  const [isNavVisible, setIsNavVisible] = useState(false); // Track navigation visibility

  const toggleNav = () => {
    setIsNavVisible(!isNavVisible);
    setIsClick(!isClick); // Toggle submenu
  };
  const [selectedNav, setSelectedNav] = useState("Contact");

  function handleSelected(selectedButton) {
    setSelectedNav(selectedButton);
  }
  return (
    <>
      <Header>
        <div id="header_wrap">
          <div className="header_top">
            <div className="container">
              <div className="container_bg">
                <div className="site_branding">
                  <a href="/" rel="home" title="Multitibe">
                    <img src={logo} alt="Multitibe" />
                  </a>
                </div>
                <div className="contact_wrap">
                  <div className="animated_contact_info">
                    <div className="location flex_icon ">
                      <a href="/">
                        <i class="fa-solid fa-location-dot"></i>
                      </a>
                      <p>
                        <label htmlFor="">ADDRESS </label>
                        <br />
                        5, Olusoji Idowu Street, Ilupeju, Lagos
                      </p>
                    </div>
                    <div className="phone flex_icon">
                      <a href="tel: +234 703 957 1467">
                        <i className="fa-solid fa-phone-volume fa-shake"></i>
                      </a>
                      <p>
                        <label htmlFor="">CALL US</label>
                        <br />
                        +234 703 957 1467
                      </p>
                    </div>
                  </div>
                  <div className="social_icons">
                    <a
                      className="fa"
                      href="https://www.facebook.com/share/1L9c5YmUit/?mibextid=wwXIfr"
                      title="Facebook"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-facebook-f custom-icon"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/radeintegratedservicesltd?igsh=eGsxczI2ZmJtdGRy&utm_source=qr"
                      title="Instagram"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-instagram"></i>
                    </a>
                    <a
                      href="https://www.tiktok.com/@radeintegratedservices?_t=ZN-8w3lzrVdp1q&_r=1"
                      title="Tiktok"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-tiktok"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="header_bottom">
            <div className="container">
              <nav className="main_navigation">
                <ul>
                  <li>
                    <a
                      href="/"
                      className={selectedNav === "Home" ? "active" : ""}
                      onCLick={() => handleSelected("Home")}
                    >
                      Home
                    </a>
                  </li>
                  <li>
                    <a
                      href="/about"
                      className={selectedNav === "About" ? "active" : ""}
                      onCLick={() => handleSelected("About")}
                    >
                      About
                    </a>
                  </li>
                  <li>
                    <a
                      href="/services"
                      className={selectedNav === "Services" ? "active" : ""}
                      onCLick={() => handleSelected("Services")}
                    >
                      Services
                    </a>
                  </li>
                  <li>
                    <a
                      href="/contact"
                      className={selectedNav === "Contact" ? "active" : ""}
                      onCLick={() => handleSelected("Contact")}
                    >
                      Contact
                    </a>
                  </li>
                </ul>
              </nav>
              <div className="mobile_container">
                <div className="open-menu" onClick={toggleNav}>
                  {!isClick ? (
                    <i
                      class="fa-solid fa-bars"
                      style={{ marginLeft: "10px" }}
                    ></i>
                  ) : (
                    <i class="fa-solid fa-x"></i>
                  )}
                </div>
                {isNavVisible && (
                  <nav className="mobile_navigation">
                    <ul>
                      <li>
                        <a
                          href="/"
                          className={
                            selectedNav === "Home" ? "mobile_active" : ""
                          }
                          onCLick={() => handleSelected("Home")}
                        >
                          Home
                        </a>
                      </li>
                      <li>
                        <a
                          href="/about"
                          className={
                            selectedNav === "About" ? "mobile_active" : ""
                          }
                          onCLick={() => handleSelected("About")}
                        >
                          About
                        </a>
                      </li>
                      <li>
                        <a
                          href="/services"
                          className={
                            selectedNav === "Services" ? "mobile_active" : ""
                          }
                          onCLick={() => handleSelected("Services")}
                        >
                          Services
                        </a>
                      </li>
                      <li>
                        <a
                          href="/contact"
                          className={
                            selectedNav === "Contact" ? "mobile_active" : ""
                          }
                          onCLick={() => handleSelected("Contact")}
                        >
                          Contact
                        </a>
                      </li>
                    </ul>
                  </nav>
                )}
                {/* <div className="open-menu">
                              <i
                                class="fa-solid fa-bars"
                                style={{ marginLeft: "10px" }}
                              ></i>
                            </div>
                            <nav className="mobile_navigation">
                              <ul>
                                <li>
                                  <a
                                    href="/"
                                    className={
                                      selectedNav === "Home" ? "mobile_active" : ""
                                    }
                                    onCLick={() => handleSelected("Home")}
                                  >
                                    Home
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="/about"
                                    className={
                                      selectedNav === "About" ? "mobile_active" : ""
                                    }
                                    onCLick={() => handleSelected("About")}
                                  >
                                    About
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="/services"
                                    className={
                                      selectedNav === "Services" ? "mobile_active" : ""
                                    }
                                    onCLick={() => handleSelected("Services")}
                                  >
                                    Services
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="/contact"
                                    className={
                                      selectedNav === "Contact" ? "mobile_active" : ""
                                    }
                                    onCLick={() => handleSelected("Contact")}
                                  >
                                    Contact
                                  </a>
                                </li>
                              </ul>
                            </nav> */}
              </div>
            </div>
          </div>
        </div>
      </Header>
      <ContactStyled>
        <div className="container">
          <div className="contact_container">
            <iframe
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3963.7962718037397!2d3.3635719625056586!3d6.5473888937955484!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b8d9648c5c9cd%3A0x3ab34293a176baf2!2s5%20Olusoji%20Idowu%20St%2C%20Ilupeju%2C%20Lagos%20102215%2C%20Lagos!5e0!3m2!1sen!2sng!4v1759807898314!5m2!1sen!2sng"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
            <div className="contact_info">
              <h2>Contact Us</h2>
              <div className="section_3 section_width">
                <li>
                  <i class="fa-solid fa-location-dot"></i>
                  <span>
                    <span style={{ fontWeight: "300" }}>Address:</span> 5,
                    Olusoji Idowu Street, Ilupeju, Lagos
                  </span>
                </li>
                <li>
                  <i class="fa-solid fa-phone"></i>
                  <span>
                    <span style={{ fontWeight: "300" }}>Phone:</span> +234 703
                    9571 467, <br /> +234 810 3690 175
                  </span>
                </li>
                <li>
                  <i class="fa-solid fa-envelope"></i>
                  <span>
                    <span style={{ fontWeight: "300" }}>Email:</span>{" "}
                    info@multibeauto.com
                  </span>
                </li>
              </div>
            </div>
          </div>
        </div>
      </ContactStyled>
      <Footer>
        <div className="container">
          <div className="footer_section">
            <div className="section_1 section_width">
              <h3>Multibe Autos</h3>
              <p>
                Multibe Autos is your trusted partner for all your automotive
                needs.
              </p>
              <div className="social_icons">
                <a
                  className="fa"
                  href="https://www.facebook.com/share/1L9c5YmUit/?mibextid=wwXIfr"
                  title="Facebook"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class="fa-brands fa-facebook-f custom-icon"></i>
                </a>
                <a
                  href="https://www.instagram.com/radeintegratedservicesltd?igsh=eGsxczI2ZmJtdGRy&utm_source=qr"
                  title="Instagram"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class="fa-brands fa-instagram"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@radeintegratedservices?_t=ZN-8w3lzrVdp1q&_r=1"
                  title="Tiktok"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class="fa-brands fa-x-twitter"></i>
                </a>
              </div>
            </div>
            <div className="section_2 section_width">
              <h3>Services</h3>
              <li>
                <a href="/services">
                  <i class="fa-solid fa-check"></i>Auto Interior Services
                </a>
              </li>
              <li>
                <a href="/services">
                  <i class="fa-solid fa-check"></i>Auto Spray Services
                </a>
              </li>
              <li>
                <a href="/services">
                  {" "}
                  <i class="fa-solid fa-check"></i>Automobile Upgrading
                </a>
              </li>
              <li>
                <a href="/services">
                  <i class="fa-solid fa-check"></i>Automobile Dealership
                </a>
              </li>
              <li>
                <a href="/services">
                  <i class="fa-solid fa-check"></i>Import & Export Trade
                </a>
              </li>
              <li>
                <a href="/services">
                  {" "}
                  <i class="fa-solid fa-check"></i>Spare Parts
                </a>
              </li>
            </div>
            <div className="section_3 section_width">
              <h3>Contact information</h3>
              <li>
                <i class="fa-solid fa-location-dot"></i>
                <span style={{ opacity: 0.7 }}>
                  5, Olusoji Idowu Street, Ilupeju, Lagos
                </span>
              </li>
              <li>
                <i class="fa-solid fa-phone"></i>
                <span>
                  +234 703 957 1467 <br /> +234 810 3690 175{" "}
                </span>
              </li>
              <li>
                <i class="fa-solid fa-envelope"></i>
                <span>info@multibeauto.com</span>
              </li>
            </div>
            <div className="section_4 section_width">
              <h3>Business Hours</h3>
              <dl>
                <dt>Opening Days:</dt>
                <dd>Monday – Friday : 8:00am to 5:00pm</dd>
                <dd>Saturday : 9:00am to 4:00pm</dd>
                <dt>Vacations:</dt>
                <dd>All Sunday Days All Official</dd>
                <dd>Holidays</dd>
              </dl>
            </div>
          </div>
          <p
            style={{
              textAlign: "center",
              padding: "20px 0",
              paddingBottom: "70px",
            }}
          >
            &copy; {new Date().getFullYear()} Multibe Autos. All rights
            reserved.
          </p>
        </div>
      </Footer>
    </>
  );
};

export default Contact;
